import { CnTimePickerPro as UiCnTimePickerPro } from '@/components/cn-time-picker-pro';
import { connect, mapProps } from '@formily/react';
import { mapSize, mapStatus } from '../__builtins__';
export const CnTimePickerPro = connect(UiCnTimePickerPro, mapProps(mapSize, mapStatus));
